var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',[_c('LanguageSelector')],1),_c('v-carousel',{attrs:{"height":"100%","show-arrows-on-hover":""}},[_c('v-carousel-item',[_c('Service')],1),_c('v-carousel-item',[_c('Story')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }